/**
 * Roles that inspect a speciality rather than practise in it: the global persona and a manufacturer's
 * reader (`externe`, which a surgeon also becomes while working for a manufacturer, PT-119). No
 * patientèle of their own, nobody named — the server applies the same rule (`INSPECTOR_ROLES`).
 */
const INSPECTOR_ROLES = new Set(["global", "externe"]);

export function isInspectorRole(role: string | null | undefined): boolean {
  return INSPECTOR_ROLES.has((role ?? "").trim().toLowerCase());
}
